// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{font-family:TCCC-UnityText,sans-serif;margin:0 auto}.YchWk{overflow-x:hidden}`, "",{"version":3,"sources":["webpack://./src/app/App.module.scss"],"names":[],"mappings":"AAAA,KACE,qCAAA,CACA,aAAA,CAGF,OACE,iBAAA","sourcesContent":["body {\n  font-family: TCCC-UnityText, sans-serif;\n  margin: 0 auto;\n}\n\n.container {\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `YchWk`
};
export default ___CSS_LOADER_EXPORT___;
